import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import { TrackShipmentResponse } from "@/schemas/ship";
import { fetchTrackingData } from "@/helpers/tracking/fetchTrackingData";

export interface ShipmentsQueryParams {
  shipmentId: string;
}
interface UseTrackShipmentOptions extends Omit<
  UseQueryOptions<
    TrackShipmentResponse,
    Error,
    TrackShipmentResponse,
    ["ship", "shipment", ShipmentsQueryParams]
  >,
  "queryKey" | "queryFn"
> {
  queryParams: ShipmentsQueryParams;
}

export const useTrackShipment = (options: UseTrackShipmentOptions) => {
  const { queryParams } = options;

  return useQuery({
    queryKey: ["ship", "shipment", queryParams],
    queryFn: async ({ queryKey, signal }): Promise<TrackShipmentResponse> => {
      const [, , params] = queryKey;
      return fetchTrackingData(params.shipmentId, signal);
    },
    refetchOnWindowFocus: false,
    ...options,
  });
};
